import React, { useState, useEffect, useContext } from "react";
import {
  Box, List, ListItem, Typography, Card, CardHeader, CardContent,
  Divider, AppBar, Toolbar, IconButton, Button
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import getOrders from "../api/user/getOrders";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { green, red } from "@mui/material/colors";
import { isPast, parseISO, format } from "date-fns";
import { AuthContext } from "../context/AuthContext";
import refundOrder from "../api/order/refundOrder";
import ConfirmDialog from "../component/ConfirmDialog";
import backIcon from "../icons/page_back.png";
const MyOrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [confirmOnly, setConfirmOnly] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const userContext = useContext(AuthContext);
  const handleBackButtonClick = () => {
    navigate("/app");
  };
  const handleRefund = async (orderId) => {
    try {
      const response = await refundOrder(orderId);
      if (response.code === "000") {
        setOrders(orders.filter(order => order.OrderId !== orderId)); // Remove order from list
        setDialogOpen(false); // Close the dialog
      } else if (response.code === "refund_pending") {
        setDialogTitle("取消處理中");
        setDialogContent("發票作廢與訂單取消正在處理，完成前訂位仍會保留。");
        setConfirmOnly(true);
        setDialogOpen(true);
      } else {
        throw new Error("Refund process failed.");
      }
    } catch (error) {
      console.error("Refund failed", error);
      setDialogTitle("退款失敗");
      setDialogContent("退款未成功。可能退款次數達到上限或稍後重試。");
      setConfirmOnly(true);
      setDialogOpen(true); // Open the dialog with error message
    }
  };

  const onRefundClicked = (orderId) => {
    setCurrentOrderId(orderId);
    setDialogTitle("取消訂單");
    setDialogContent("退費將會以優惠券形式發放，每個月可以使用三次，請確認是否取消訂單？");
    setConfirmOnly(false);
    setDialogOpen(true); // Prepare and open the confirmation dialog
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog

  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getOrders();
        if (response.orders) {
          setOrders(response.orders);
        }
      } catch (error) {
        console.error("Failed to fetch orders", error);
      }
    }

    if (userContext.user) fetchData();
  }, [userContext.user]);

  return (
    <Box width="100%" height="100vh" sx={{ backgroundColor: theme.palette.background.default }}>
      <AppBar           sx={{ bgcolor: theme.palette.appBar }}
          position="sticky"
          color="secondary">
        <Toolbar  sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <Box
              component="img"
              src={backIcon}
              alt="back"
              sx={{ width: "50px", marginLeft: "-16px" }}
              onClick={handleBackButtonClick}
            />
          <Typography
              align="center"
              sx={{
                fontWeight: "bold",
                fontSize: "h6.fontSize",
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
          >我的訂單</Typography>
        </Toolbar>
      </AppBar>
      <Box m={1} />
      {userContext.user === null ? (
        <Typography marginTop={20} fontSize={"h5.fontSize"} fontWeight={"bold"} align="center">
          尚未登入
        </Typography>
      ) : (
        <List component={"nav"} aria-label="user orders" sx={{ backgroundColor: theme.palette.background.default }}>
          {orders.map((order, index) => (
            <React.Fragment key={order.OrderId}>
              <ListItem>
                <Card variant="outlined" style={{ width: "100%" }}>
                  <CardHeader
                    avatar={
                      <FilterFramesIcon
                        style={order.PaymentStatus === "已付款" && order.Status !== "已退款" ? { color: green[500] } : { color: red[500] }}
                      />
                    }
                    title={order.StoreName}
                    subheader={order.TableName}
                  />
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">
                      {`編號:${order.OrderId}`}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                      {`訂位時間:${format(parseISO(order.ReservationStartTime), "yyyy/MM/dd HH:mm")}~${format(parseISO(order.ReservationEndTime), "yyyy/MM/dd HH:mm")}`}
                    </Typography>

                    <Typography variant="body2" color="textSecondary" component="p">
                      {`付款狀態:${order.PaymentStatus}`}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                      {`總計:$${order.Total}`}
                    </Typography>
                    {order.PaymentStatus === "已付款" && order.Status !== "已退款" && !isPast(parseISO(order.ReservationStartTime)) && (
                      <Button variant="contained" color="warning" onClick={() => onRefundClicked(order.OrderId)} sx={{ mt: 2 }}>
                        退款並取消訂單
                      </Button>
                    )}
                  </CardContent>
                </Card>
              </ListItem>
              {index !== orders.length - 1 && <Divider variant="middle" />}
            </React.Fragment>
          ))}
        </List>
      )}
      <ConfirmDialog open={dialogOpen} onConfirm={confirmOnly ? handleDialogClose : () => handleRefund(currentOrderId)} onClose={handleDialogClose} title={dialogTitle} content={dialogContent} confirmOnly={confirmOnly}/>
    </Box>
  );
};

export default MyOrderPage;
